import useCustomFormatter from '@/presentation/utils/numberFormatter';
import { NumberFormatOptions } from 'use-intl';

const FormattedEther = ({
  value,
  ...opts
}: {
  value?: bigint;
} & NumberFormatOptions) => {
  const { bigintToEth } = useCustomFormatter();
  return <>{bigintToEth(value, opts)}</>;
};

export default FormattedEther;
